import { render } from "./QueuedScrap.vue?vue&type=template&id=277c5929&scoped=true"
import script from "./QueuedScrap.vue?vue&type=script&lang=js"
export * from "./QueuedScrap.vue?vue&type=script&lang=js"

import "./QueuedScrap.vue?vue&type=style&index=0&id=277c5929&lang=scss&scoped=true"

import exportComponent from "/Users/leopons/Desktop/Projects/cryptos/bubble-graph/bubblemaps-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277c5929"]])

export default __exports__